import { useAppDispatch, useAppSelector } from "@src/store/hooks";
import { Outlet } from "react-router-dom";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { MainContainer } from "./Home.styled";
import { settingsActions } from "@src/store";
import { EventFiltersProvider } from "@src/context/EventFiltersContext";

const Home = () => {
	const appDispatch = useAppDispatch();
	const portalSidebarExpanded = useAppSelector((state) => state.settings.portalSidebarExpanded);
	const portalSidebarIsHidden = useAppSelector((state) => state.settings.portalSidebarIsHidden);

	const toggleExpanded = () => {
		appDispatch(settingsActions.setPortalSidebarExpanded(!portalSidebarExpanded));
	};

	return (
		<EventFiltersProvider>
			<MainContainer $isExpanded={portalSidebarExpanded} $isSideBarHidden={portalSidebarIsHidden}>
				<Header />
				<Sidebar isHidden={portalSidebarIsHidden} isExpanded={portalSidebarExpanded} toggleExpanded={toggleExpanded} />
				<div className={"childRoutesContainer"}>
					<main>
						<Outlet />
					</main>
				</div>
			</MainContainer>
		</EventFiltersProvider>
	);
};

export default Home;
